import React from 'react'
import { GroundPlanContext } from 'src/contexts'
import { PlanZoomObserver } from 'src/observers'

function Background() {
  const {
    height,
    width,
    background: { url },
  } = GroundPlanContext.use()

  const transform = PlanZoomObserver.useValue()

  return (
    <g transform={transform.toString()}>
      <image href={url} width={width} height={height} />
    </g>
  )
}

export default Background
